import IEventService from '../../../services/eventService/IEventService';
import { getServices } from '../../../infra/startup';
import bindAllMethods from '../../../utils/bindAllMethods';
import * as T from '@clientos/types';

class EventsInterfaceV1 {
  private _eventService: IEventService;

  constructor() {
    const services = getServices();
    this._eventService = services.eventService;
    bindAllMethods(this);
  }

  public getInterface(): T.EventsInterfaceType {
    return {
      //@ts-expect-error We need to update the EventName in types
      shellEventNames: this._eventService.eventNames,
      addEventListener: this._eventService.addEventListener,
      removeEventListener: this._eventService.removeEventListener,
      triggerEvent: this._triggerEvent
    };
  }

  private _triggerEvent(name: string, event: T.EventValueType): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._eventService.publish(name, event);
  }
}

export default EventsInterfaceV1;
